
import CreateNewFolderRoundedIcon from '@mui/icons-material/CreateNewFolderRounded';
import AccountBoxRoundedIcon from '@mui/icons-material/AccountBoxRounded';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import GridViewIcon from '@mui/icons-material/GridView';
import BusinessIcon from '@mui/icons-material/Business';

export const pages = [
    {
        name: 'New Tender',
        icon: <CreateNewFolderRoundedIcon />,
        path: '/NewTender'
    },
    {
        name: 'Manage Tender',
        icon: <RotateRightIcon />,
        path: '/AdvanceTender'
    },
    {
        name: 'Finalized Tenders',
        icon: <GridViewIcon />,
        path: '/TenderOverview'
    },
    {
        name: 'Departments',
        icon: <BusinessIcon />,
        path: '/departments'
    },
];

export const adminPages = [
    {
        name: 'Export Tender',
        icon: <FileDownloadRoundedIcon />,
        path: '/Export'
    },
    {
        name: 'Admin Overview',
        icon: <AccountBoxRoundedIcon />,
        path: '/Admin'
    },
    {
        name: 'Analytics',
        icon: <QueryStatsRoundedIcon />,
        path: '/Analytics'
    }
    
];


export const hiddenPages = [

    {
        name: 'Import ',
        icon: <AccountBoxRoundedIcon />,
        path: '/Import'
    }
]

export const viewerPages = [
    {
        name: 'Manage Tender',
        icon: <RotateRightIcon />,
        path: '/AdvanceTender'
    },
    {
        name: 'Finalized Tenders',
        icon: <GridViewIcon />,
        path: '/TenderOverview'
    },
]
